module.exports = __webpack_public_path__ + "static/media/remove.b175098f.svg";